module.exports = __webpack_public_path__ + "static/img/R200_bg.86fe399.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/R200_bg.jpg
// module id = Zmnn
// module chunks = 0